import { Link } from 'react-router-dom'

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-900 dark:text-white mb-4">
          404
        </h1>
        <h2 className="text-3xl font-semibold text-gray-700 dark:text-gray-300 mb-4">
          Página não encontrada
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          A página que você está procurando não existe ou foi removida.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-primary hover:bg-primary-hover text-white font-medium rounded-btn transition-colors"
        >
          Voltar ao Dashboard
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
